import React from 'react';
import ConfirmationDialog from 'ui/dialog/ConfirmationDialog';
import { ActionTypes } from '../Consts';

export function DeleteConfirm({ name, onAction }) {
    const title = `Delete ${name} Connector`;
    const info = `Delete the ${name} Connector will convert all sync'd users to
        unmanaged users. You will then be able to manage those users in
        CyberFOX Password Manager, or re-add the ${name} Connector and continue
        to manage the users in ${name}.`;
    const ask = `Delete the ${name} Connector`;
    return (
        <ConfirmationDialog
            open={true}
            title={title}
            subtitle1={info}
            subtitle2={ask}
            onCancel={() => onAction(ActionTypes.RESET)}
            onOk={() => onAction(ActionTypes.REMOVE_CONFIRMED)}
            showCancelButton={true}
        />
    );
}

export function CreateNewConfirm({ name, onAction }) {
    const title = `Create new ${name} token`;
    const info = `When you create a new authentication token the existing token
    is immediately deleted. After creating a new token you will need to add the
     new token to the ${name} Connector application installed on your server.`;
    const ask = 'Create new token?';
    return (
        <ConfirmationDialog
            open={true}
            title={title}
            subtitle1={info}
            subtitle2={ask}
            onCancel={() => onAction(ActionTypes.RESET)}
            onOk={() => onAction(ActionTypes.CREATE_NEW_CONFIRMED)}
            showCancelButton={true}
        />
    );
}
